module.exports = __webpack_public_path__ + "static/img/02-banner2.12c80f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/02-banner2.jpg
// module id = CZXH
// module chunks = 1